document.addEventListener("DOMContentLoaded", function() {
  function enhanceLoopWidget() {
    const subOption = document.querySelector(
      ".loop-widget-purchase-option-selected .loop-widget-spg-container"
    );
    if (subOption && !subOption.querySelector(".custom-subscription-benefits")) {
      const benefits = document.createElement("ul");
      benefits.className = "custom-subscription-benefits";
      // benefits.innerHTML = `
      //   <li>Delivery 30 days</li>
      //   <li>Cancel or adjust any time</li>
      //   <li>Free AUS shipping</li>
      // `;
      subOption.appendChild(benefits);
    }

    document.querySelectorAll(".loop-widget-purchase-option-price").forEach((priceEl, idx) => {
      if (!priceEl.parentElement.querySelector(".custom-per-serving")) {
        const perServing = document.createElement("span");
        perServing.className = "custom-per-serving";
        perServing.textContent = idx === 0 ? "$2.40 / serving" : "$2.66 / serving";
        priceEl.after(perServing);
      }
    });
  }

  setTimeout(enhanceLoopWidget, 2000);
  document.addEventListener("loop:widget:updated", enhanceLoopWidget);
});
